<template>
    <modal
      title="Make Default"
      width="35"
      :showModal="showModal"
      @close-modal="$emit('closeModal')"
    >
      <div>
        <div class="mt-3 py-2 px-2 border-2 border-gray-200 rounded-md">
           <div class="flex items-center justify-between pb-2">
              <span class="opacity-50">Account Name:</span>
              <span>Ada Ibeh</span>
           </div> 
           <div class="flex items-center justify-between">
            <span class="opacity-50">MRN #:</span>
            <span>100234578</span>
         </div>
        </div>

        <div class="p-0 my-3 border-dashed border-t-2 border-gray-300"></div>
  
        <div class="mt-3 py-2 px-2 border-2 border-gray-200 rounded-md">
            <div class="flex items-center justify-between pb-2">
               <span class="opacity-50">Current Default:</span>
               <span class="text-right">NOVO Insurance | 200097748 Expiry</span>
            </div> 
            <div class="flex items-center justify-between">
             <span class="opacity-50"></span>
             <span class="text-right">Date: 23 - 03 - 2023</span>
          </div>
         </div>
  
        <div class="flex justify-end mt-48">
          <button @click="$emit('closeModal')">Cancel</button>
  
          <button @click="createWallet" class="w-24 bg-primary-yellow py-2 text-center ml-4 rounded-md">
            Save
          </button>
        </div>
      </div>
    </modal>
  </template>
  
  <script>
  export default {
    props: {
      showModal: {
        type: Boolean,
      },
    },
    data() {
      return {
        currencies: ['NGN'],
        wallet : {
          currency: "NGN"
        }
      }
    },
    methods: {
      async createWallet() {
        try {
          await this.$_createWallet({
            userId: localStorage.getItem("userId"),
          });
          this.$router.push("/settings/wallet-details");
        } catch (error) {
          this.handleError(error);
        }
      },
    },
  };
  </script>
  
  <style scoped lang="scss">
  .input {
    @apply w-12 h-12 text-primary-black border-2 border-gray-300 flex text-center items-center rounded-md mx-2;
  }
  .el-select{
    margin-bottom: 0
  }
  .border_1{
    border-width: 1px;
  
  }
  </style>
  